// src/pages/dashboard/components/AIAlerts.js
import React, { useState, useEffect } from 'react';

const AIAlerts = () => {
  const [alerts, setAlerts] = useState([]);

  useEffect(() => {
    // Simulate API call to fetch AI alerts
    const fetchAlerts = async () => {
      const response = await fetch('/api/alerts'); // Replace with real API endpoint
      const data = await response.json();
      setAlerts(data);
    };

    fetchAlerts();
  }, []);

  return (
    <div>
      <h3>AI Alerts</h3>
      <ul>
        {alerts.map((alert) => (
          <li key={alert.Id}>
            <strong>{alert.Event}</strong>: {alert.Description}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default AIAlerts;
